import {
  Dropdown,
  Menu,
  Avatar,
} from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { userImplement } from '@/config/hooks/user';
import { ENV } from '@/infrastructure/env-config';

export const AvatarMenu = () => {
  const history = useHistory();
  const handleSelect = (key: string) => {
    switch (key) {
      case 'myApp':
        history.push('/workbench/apps');
        break;
      case 'profile':
        history.push('/user/profile');
        break;
      case 'coupons':
        history.push('/user/coupons');
        break;
      case 'resourceManage':
        history.push('/resource-manage');
        break;
      case 'expense':
        history.push('/expense');
        break;
      case 'token':
        history.push('/user/token');
        break;
      default:
        userImplement.logout();
        break;
    }
  };

  const menu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myApp">
        我的产品
      </Menu.Item>
      <Menu.Item key="profile">
        个人信息
      </Menu.Item>
      {(!ENV.isOverseas) && <Menu.Item key="expense">
        订单管理
      </Menu.Item>}
      <Menu.Item key="resourceManage">
        资源包
      </Menu.Item>
      <Menu.Item key="token">
        个人令牌
      </Menu.Item>
      <Menu.Item key="logout">
        退出登录
      </Menu.Item>
    </Menu>
  );

  return <Dropdown overlay={menu} placement={'bottomRight'}>
    <Avatar style={{ marginBottom: '5px' }} size={28} src={userImplement.getAvatar()} />
  </Dropdown>;
};
